// Role-specific multilingual FAQ. Regenerate: node scripts/build-faq-i18n.mjs
import { faqAdmin } from './faq/faqAdmin.js';
import { faqManager } from './faq/faqManager.js';
import { faqCoach } from './faq/faqCoach.js';
import { faqStudent } from './faq/faqStudent.js';
import { faqParent } from './faq/faqParent.js';

export const faqData = {
  ADMIN: faqAdmin,
  MANAGER: faqManager,
  COACH: faqCoach,
  STUDENT: faqStudent,
  PARENT: faqParent,
};
